import { Action } from '@ngrx/store';
import { Parameter } from '../models/parameter.model';

export enum ActionTypes {
    FETCH_COUNTRY_PARAMETERS            = '[Country Parameters API] Fetch Country Parameters',
    FETCH_COUNTRY_PARAMETERS_SUCCESSS   = '[Country Parameters Page] Fetch Country Parameters Success',
    CLEAR_COUNTRY_PARAMETERS            = '[Country Parameters Page] Clear Country Parameters',
}

export class FetchCountryParameters implements Action {
    readonly type: string  = ActionTypes.FETCH_COUNTRY_PARAMETERS;

    constructor(public payload?: any) {}
}

export class ClearCountryParameters implements Action {
    readonly type: string = ActionTypes.CLEAR_COUNTRY_PARAMETERS;

    constructor(public payload?: any) {}
}

export class FetchCountryParametersSuccess implements Action {
    readonly type: string = ActionTypes.FETCH_COUNTRY_PARAMETERS_SUCCESSS;

    constructor(public payload: Parameter[]) {}
}

export type Actions =
    | FetchCountryParameters | ClearCountryParameters | FetchCountryParametersSuccess;
